/* tslint:disable:no-any */
import { getMethodTooManyArgsErrorMsg } from './errorMessages';

export class MethodMeta {
  public readonly property: string;
  public readonly name: string;
  public readonly hasParams: boolean;

  public schema?: object;

  constructor({ func, name, givenName }: { func: () => any; name?: string; givenName?: string }) {
    this.property = name || func.name;
    if (func.length > 1) {
      throw Error(getMethodTooManyArgsErrorMsg(this.property));
    }

    this.name = givenName || this.property;
    this.hasParams = func.length > 0;
  }
}
